<template>
    <div class="modal fade show modal-style" aria-labelledby="confirmMoneyReceiptTitle">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                            <h1 class="mb-0" id="confirmMoneyReceiptTitle">Confirm Money Receipt</h1>
                            <button
                                @click="onClose"
                                type="button"
                                class="btn-close"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="p-2">
                    <ul class="list-unstyled mb-0 confirm-list">
                        <li>
                            <span class="confirm-label"><i class="fas fa-user me-1"></i>Selected Client</span>
                            <span class="confirm-value">{{ clientLabel }}</span>
                        </li>
                        <li>
                            <span class="confirm-label"><i class="fas fa-user-injured me-1"></i>Selected User Count</span>
                            <span class="confirm-value">{{ patientCount }}</span>
                        </li>
                        <li>
                            <span class="confirm-label"><i class="fas fa-file-invoice me-1"></i>Selected Bill Count</span>
                            <span class="confirm-value">{{ billCount }}</span>
                        </li>
                        <li>
                            <span class="confirm-label"><i class="fas fa-scale-balanced me-1"></i>Total Due Amount</span>
                            <span class="confirm-value">{{ commaFormat(totalDue) }}</span>
                        </li>
                        <li class="highlight">
                            <span class="confirm-label"><i class="fas fa-wallet me-1"></i>Collection Amount</span>
                            <span class="confirm-value">{{ commaFormat(collectionAmount) }}</span>
                        </li>
                    </ul>

                    <div class="d-flex gap-1 mt-2">
                        <button @click="onConfirm" class="btn btn-primary flex-fill">
                            Confirm & Save
                        </button>
                        <button @click="onClose" class="btn btn-outline-secondary flex-fill">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import figureFormatter from "@/services/utils/figureFormatter";

defineProps({
    clientLabel: String,
    patientCount: Number,
    billCount: Number,
    totalDue: Number,
    collectionAmount: Number
})

const emit = defineEmits(['onConfirm', 'onClose']);
const { commaFormat } = figureFormatter()

const onConfirm = () => {
    emit('onConfirm');
}

const onClose = () => {
    emit('onClose');
}
</script>

<style scoped>
.modal-style {
    display: block;
    background: #1c1d1c33
}
.confirm-list li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.confirm-list li:last-child {
    border-bottom: none;
}
.confirm-list li.highlight {
    background: #eeedfd;
    border-radius: 8px;
    padding: 12px;
    margin-top: 4px;
}
.confirm-label {
    color: #6e6b7b;
    font-weight: 600;
}
.confirm-value {
    font-weight: 700;
    color: #2f3a4c;
}
</style>
